import { CarehomeDto } from './../../../dto/carehomedto'
import { UserDto, UserPermissionDto } from "./../../../dto/Dtos";
import Dal from './../../../scripts/dataaccess'



export class UserListItem {
    public userid: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public number: string;
    public carehomeId: string;
    public carehomeName: string;
    public permissionId: number;
    public permissionName: string;
}

export class UserListController{

    public IsLoading: boolean = true;
    public Records: Array<UserListItem>;

    private managedCarehomes: Array<CarehomeDto>;

    public constructor(managedCarehomes: Array<CarehomeDto>) {
        this.managedCarehomes = managedCarehomes;
    }

    public async Load(): Promise<Array<UserListItem>>{
        console.log("askdjalskdbalsdblas 1")
        var dal = new Dal();
        var that = this;
        var carehomePromise = dal.GetCarehomes();
        var userPromise = dal.GetUsers();
        console.log("askdjalskdbalsdblas 2")
        return Promise.all([carehomePromise, userPromise]).then(values => {
            console.log("askdjalskdbalsdblas 3", values)
            var carehomes = values[0];
            var users = values[1];

            that.Records = that.LoadData(that.managedCarehomes, users, carehomes);
            that.IsLoading = false;
            console.log("askdjalskdbalsdblas 4", that.Records)
            return that.Records;
        });
    }


    public LoadData(
        managedCarehomes: Array<CarehomeDto>,
        users: Array<UserDto>,
        carehomes: Array<CarehomeDto>)
        : Array<UserListItem> {

        var result = new Array<UserListItem>();

        for (var user of users) {
            for (var permission of user.userPermissions) {
                var carehome = managedCarehomes.find(c => c.id == permission.carehomeId);
                if (carehome) {
                    
                    // this user is from a carehome managed by the current user
                    var record = new UserListItem();

                    record.userid = user.id;
                    record.firstName = user.firstName;
                    record.lastName = user.lastName;
                    record.email = user.email;
                    record.number = user.number;
                    record.carehomeId = permission.carehomeId;
                    record.carehomeName = carehome.name;
                    record.permissionId = permission.permissionId;
                    record.permissionName = permission.permissionId == 3 ? "Manager" : "Carer";

                    result.push(record);
                }
            }
        }

        return result;
    }

}


// WEBPACK FOOTER //
// ./ClientApp/components/pages/user-list/UserListController.ts